export default "__VITE_ASSET__8baad3e6__"